import { API } from 'aws-amplify';

const apiName = 'uruk-back';

async function createFlow (body) {
  try {
    return API.post(apiName, '/createFlow', { body });
  } catch (err) {
    console.log('## ERROR: ', err);
    throw err;
  }
}

async function createBundle (body) {
  try {
    return API.post(apiName, '/bundle', { body });
  } catch (err) {
    console.log('## ERROR: ', err);
    throw err;
  }
}

async function cancelFlow (body) {
  return API.post(apiName, '/cancelFlow', { body });
}

async function cancelBundle (body) {
  return API.post(apiName, '/cancelBundle', { body });
}

async function createOnBoarding (body) {
  return API.post(apiName, '/createOnBoarding', { body }).catch((err) => {
    console.log('## ERROR: ', err);
    throw new Error(err.response.data.message);
  }
  );
}

async function deleteBiometricIdentity (body) {
  return API.post(apiName, '/deleteBiometricIdentity', { body }).catch((err) =>
    console.log('## ERROR: ', err)
  );
}

async function generateDocs (body) {
  return API.post(apiName, '/generateDocs', { body });
}

async function launchBundle (body) {
  const endpointBunldeVersion = body.bundleVersion === 2 ? `/bundles/${body.bundleId}/flow` : '/createBundleFlow';
  return API.post(apiName, endpointBunldeVersion, { body });
}

async function relaunchStep (body) {
  return API.post(apiName, '/flow/relaunch', { body }).catch((err) =>
    console.log('## ERROR: ', err)
  );
}

async function getAudit (sid) {
  return API.get(apiName, `/audit/${sid}`);
}

async function getCertificate (flowId) {
  return API.get(apiName, `/certificate/${flowId}`).catch((err) =>
    console.log('## ERROR: ', err)
  );
}

async function getApplication (id) {
  return API.get(apiName, `/application/${id}`).catch((err) =>
    console.log('## ERROR: ', err)
  );
}

async function setDefaultContext (id, body) {
  return API.put(apiName, `/config/defaultContext/${id}`, { body }).catch((err) =>
    console.log('## ERROR: ', err)
  );
}

async function getDataFromFlowAndStep ({ flowId, stepId }) {
  return API.get(apiName, `/sign/data/${flowId}/${stepId}`).catch((err) =>
    console.log('## ERROR: ', err)
  );
}

async function getPresignUrlFromS3BucketAttachments (body) {
  return API.post(apiName, '/files', { body }).catch((err) =>
    console.log('## ERROR: ', err)
  );
}

async function getZipFilesFromBundle (body) {
  try {
    return await API.post(apiName, '/getFilesFromBundle', { body });
  } catch (error) {
    console.log('## ERROR: ', error);
    throw error;
  }
}

async function createNotification (body) {
  return API.post(apiName, '/notifications', { body });
}

async function getTemplatesNotification (type) {
  return API.get(apiName, `/admin/templates?format=${type}`);
}

async function createBulkNotification (body) {
  return API.post(apiName, '/bulkNotifications', { body });
}

async function exportData (body) {
  return API.post(apiName, '/export/data', { body });
}

const API_REST = {
  cancelBundle,
  createFlow,
  createBundle,
  cancelFlow,
  createOnBoarding,
  createNotification,
  deleteBiometricIdentity,
  generateDocs,
  launchBundle,
  getAudit,
  relaunchStep,
  getCertificate,
  getApplication,
  setDefaultContext,
  getDataFromFlowAndStep,
  getPresignUrlFromS3BucketAttachments,
  getZipFilesFromBundle,
  getTemplatesNotification,
  createBulkNotification,
  exportData
};

export default API_REST;
